import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const DispatchSummaryExportsAccessRight = {
  VIEW_EXPORT_DISPATCH_SUMMARIES_LIST: () => true,
  CREATE_EXPORT_DISPATCH_SUMMARIES: () => true,
} satisfies Record<string, AuthenticationAccessRight>;
